<template>
<!-- 试卷管理 -->
    <div >
        <el-card class="fatherCard">
            <div slot="header">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item><i class="el-icon-location-outline"></i> <b>当前位置</b></el-breadcrumb-item>
                    <el-breadcrumb-item>考试管理</el-breadcrumb-item>                
                    <el-breadcrumb-item>试卷管理</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div>
                <el-tabs v-model="activeName"  class="elTab" @tab-click="backToManagerPaper()">
                    <el-tab-pane label="试卷管理" name="first" >
                        <div v-show="!modifyFlag" class="list_container">                  
                            <div class="search_container" >
                                <div>
                                    <el-input v-model="paperQueryParams.paperName" clearable placeholder="试卷关键词" class="impoWorldInput"></el-input>
                                    <el-button type="primary" @click="queryExamPapers()">查询</el-button>
                                </div>
                                <el-button type="danger" @click="deleteSelectedPapers()" class="searchButton">批量删除</el-button>
                                
                            </div>   
                            <el-table :data="paperList"  stripe highlight-current-row class="paperTable" max-height="600px"
                                :header-cell-style="{background:'#eef1f6',color:'#606266'}"
                                ref="multipleTable" @selection-change="selectPapersChange">  
                                <el-table-column  type="selection" width="55"></el-table-column>
                                <el-table-column fixed="left" label="序号" align="center" type="index" width="50" ></el-table-column>      
                                <el-table-column fixed="left" prop="paperName" label="试卷名称" width="250px" align="center" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="paperId" label="试卷ID" v-if="false"></el-table-column>
                                <el-table-column prop="paperScore" label="试卷总分" width="80px" align="center"></el-table-column>
                                <el-table-column prop="passScore" label="及格分" width="80px" align="center"></el-table-column>
                                <el-table-column prop="paperMsg" label="试卷信息" align="center" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="createBy" label="创建者"  align="center"> </el-table-column>
                                <el-table-column prop="createTime" label="创建时间" width="200px" align="center">
                                    <template slot-scope="scope">{{dateFormatter(scope.row.createTime)}}</template>
                                </el-table-column>
                                <el-table-column prop="updateTime" label="最后修改时间" width="200px" align="center"> 
                                    <template slot-scope="scope">{{dateFormatter(scope.row.updateTime)}}</template>
                                </el-table-column>
                                <el-table-column  prop="state" label="试卷状态" width="100px" align="center" >
                                    <template slot="header" >
                                        <div class="switchDiv">
                                            <span>试卷状态</span>
                                            <el-switch v-model="paperSwitchValue"  active-color="#13ce66"  inactive-color="#909399"></el-switch>
                                        </div>
                                    </template>
                                    <template slot-scope="scope">{{ scope.row.state === '0' ? '禁用' : '在用' }}</template>
                                </el-table-column>
                                <el-table-column  label="操作" width="300"  align="center">
                                    <template slot-scope="scope">
                                        <el-button @click="previewPaper(scope.row)" type="success" size="mini">预览</el-button>
                                        <el-button @click="copyPaper(scope.row)" type="info" size="mini">复制</el-button>
                                        <el-button @click="modifyPaperInfo(scope.row)" type="primary" size="mini">编辑</el-button>
                                        <el-button @click="modifyState(scope.row)" :type="paperSwitchValue === true ? 'danger' : 'success'" size="mini">{{paperSwitchValue === true ? '禁用' : '启用'}}</el-button>
                                    </template>
                            </el-table-column>
                            </el-table>          
                            <el-pagination @size-change="paperSizeChange" @current-change="paperCurrentChange" layout="total, sizes, prev, pager, next, jumper"
                                :current-page="paperQueryParams.pageNum" :page-sizes="[10, 20, 50]" :page-size="paperQueryParams.pageSize" :total="paperTotalCount"  class="pagination"></el-pagination>                               
                        </div>
                        <div class="modfiyPaperContainer" v-show="modifyFlag"> 
                            <h1 class="createHeaderTitle">修改试卷</h1>
                            <div class="createContainer">
                                <el-scrollbar style="height:100%">   
                                    <table style="width: 850px"  class="createPaperTable">
                                        <tbody>
                                            <tr>
                                                <th>试卷名称</th>
                                                <td > 
                                                    <el-input  placeholder="请输入内容"   v-model="modfiyPaperForm.paperName"   disabled></el-input>
                                                    <el-input  v-if="false" v-model="modfiyPaperForm.paperId"   clearable></el-input>
                                                </td>
                                            </tr>
                                             <tr>
                                                <th>试卷信息</th>
                                                <td ><el-input  placeholder="请输入内容"   v-model="modfiyPaperForm.paperMsg"   clearable></el-input></td>                                            
                                            </tr>
                                            <tr>
                                                <th>试卷总分</th>
                                                <td > 
                                                    <span>{{modfiyPaperScore}} 分</span><span class="singAnswerTip">(该值自动计算，无需填写)</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style="min-width:120px">章节设置</th>
                                                <td>
                                                     <el-card class="articleCard">
                                                        <div slot="header" class="clearfix">
                                                            <span >{{singleSelect.partName}}（每题 <el-input-number v-model="singleSelect.questionScore" style="width:90px" size="mini"  controls-position="right"  :min="1" :max="99"></el-input-number>分）</span>
                                                            <div class="twoBtn">
                                                                <el-button type="text" @click="openAddRandomQuestion('单')">随机增加</el-button>
                                                                <span>/</span>
                                                                <el-button type="text" @click="openAddQuestionDialog('单')">手动增加</el-button>
                                                            </div>
                                                        </div>
                                                        <div class="selectBody" v-for="(item, i) in singleMultipleTable" :key="item.id" >
                                                           <div class="index_title">{{i+1}}.<div v-html="item.questionTitle" class="questionSpan"></div></div>
                                                            <div> 
                                                                <el-button @click="previewQuestion(item)" type="success" size="mini">预览</el-button>
                                                                <el-button @click="deleteSelectedQuestion(item, i)" type="danger" size="mini">删除</el-button>
                                                            </div>
                                                        </div>  
                                                    </el-card>    
                                                    <el-card class="articleCard">
                                                        <div slot="header" class="clearfix">
                                                            <span >{{multiSelect.partName}}（每题 <el-input-number v-model="multiSelect.questionScore" style="width:90px" size="mini"  controls-position="right"  :min="1" :max="99"></el-input-number>分）</span>
                                                            <div class="twoBtn">
                                                                <el-button type="text" @click="openAddRandomQuestion('多')">随机增加</el-button>
                                                                <span>/</span>
                                                                <el-button type="text" @click="openAddQuestionDialog('多')">手动增加</el-button>
                                                            </div>
                                                        </div>
                                                        <div class="selectBody" v-for="(item, i) in moreMultipleTable" :key="item.id">
                                                            <div class="index_title">{{i+1}}.<div v-html="item.questionTitle" class="questionSpan"></div></div>
                                                            <div> 
                                                                <el-button @click="previewQuestion(item)" type="success" size="mini">预览</el-button>
                                                                <el-button @click="deleteSelectedQuestion(item, i)" type="danger" size="mini">删除</el-button>
                                                            </div>
                                                        </div>  
                                                    </el-card>
                                                    <el-card class="articleCard">
                                                        <div slot="header" class="clearfix">
                                                            <span >{{judgePart.partName}}（每题 <el-input-number v-model="judgePart.questionScore" style="width:90px" size="mini"  controls-position="right"  :min="1" :max="99"></el-input-number>分）</span>
                                                            <div class="twoBtn">
                                                                <el-button type="text" @click="openAddRandomQuestion('判')">随机增加</el-button>
                                                                <span>/</span>
                                                                <el-button type="text" @click="openAddQuestionDialog('判')">手动增加</el-button>
                                                            </div>
                                                        </div>
                                                        <div class="selectBody" v-for="(item, i) in judgeMultipleTable" :key="item.id">
                                                            <div class="index_title">{{i+1}}.<div v-html="item.questionTitle" class="questionSpan"></div></div>
                                                            <div> 
                                                                <el-button @click="previewQuestion(item)" type="success" size="mini">预览</el-button>
                                                                <el-button @click="deleteSelectedQuestion(item, i)" type="danger" size="mini">删除</el-button>
                                                            </div>
                                                        </div>  
                                                    </el-card>
                                                    <el-card class="articleCard">
                                                        <div slot="header" class="clearfix">
                                                            <span >{{fillPart.partName}}（每题 <el-input-number v-model="fillPart.questionScore" style="width:90px" size="mini"  controls-position="right"  :min="1" :max="99"></el-input-number>分）</span>
                                                            <div class="twoBtn">
                                                                <el-button type="text" @click="openAddRandomQuestion('填')">随机增加</el-button>
                                                                <span>/</span>
                                                                <el-button type="text" @click="openAddQuestionDialog('填')">手动增加</el-button>
                                                            </div>
                                                        </div>
                                                        <div class="selectBody" v-for="(item, i) in fillMultipleTable" :key="item.id">
                                                            <div class="index_title">{{i+1}}.<div v-html="item.questionTitle" class="questionSpan"></div></div>
                                                            <div> 
                                                                <el-button @click="previewQuestion(item)" type="success" size="mini">预览</el-button>
                                                                <el-button @click="deleteSelectedQuestion(item, i)" type="danger" size="mini">删除</el-button>
                                                            </div>
                                                        </div>  
                                                    </el-card>
                                                    <el-card class="articleCard">
                                                        <div slot="header" class="clearfix">
                                                            <span >{{writePart.partName}}（每题 <el-input-number v-model="writePart.questionScore" style="width:90px" size="mini"  controls-position="right"  :min="1" :max="99"></el-input-number>分）</span>
                                                            <div class="twoBtn">
                                                                <el-button type="text" @click="openAddRandomQuestion('简')">随机增加</el-button>
                                                                <span>/</span>
                                                                <el-button type="text" @click="openAddQuestionDialog('简')">手动增加</el-button>
                                                            </div>
                                                        </div>
                                                        <div class="selectBody" v-for="(item, i) in writeMultipleTable" :key="item.id">
                                                            <div class="index_title">{{i+1}}.<div v-html="item.questionTitle" class="questionSpan"></div></div>
                                                            <div> 
                                                                <el-button @click="previewQuestion(item)" type="success" size="mini">预览</el-button>
                                                                <el-button @click="deleteSelectedQuestion(item, i)" type="danger" size="mini">删除</el-button>
                                                            </div>
                                                        </div>  
                                                    </el-card>  
                                                    <el-card class="articleCard">
                                                        <div slot="header" class="clearfix">
                                                            <span >{{operatePart.partName}}（每题 <el-input-number v-model="operatePart.questionScore" style="width:90px" size="mini"  controls-position="right"  :min="1" :max="99"></el-input-number>分）</span>
                                                            <div class="twoBtn">
                                                                <el-button type="text" @click="openAddRandomQuestion('实')">随机增加</el-button>
                                                                <span>/</span>
                                                                <el-button type="text" @click="openAddQuestionDialog('实')">手动增加</el-button>
                                                            </div>
                                                        </div>
                                                        <div class="selectBody" v-for="(item, i) in operateMultipleTable" :key="item.id">
                                                            <div class="index_title">{{i+1}}.<div v-html="item.questionTitle" class="questionSpan"></div></div>
                                                            <div> 
                                                                <el-button @click="previewQuestion(item)" type="success" size="mini">预览</el-button>
                                                                <el-button @click="deleteSelectedQuestion(item, i)" type="danger" size="mini">删除</el-button>
                                                            </div>
                                                        </div>  
                                                    </el-card>  
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>试卷及格分</th>
                                                <td ><el-input-number v-model="modfiyPaperForm.passScore" controls-position="right"  :min="1" ></el-input-number>
                                                </td> 
                                            </tr>
                                            <tr>
                                                <td colspan="2">
                                                    <el-button @click="submitModifyPaper()" type="success" style="width:250px;margin:20px 20px 20px 50px" :loading="submitLoading">{{submitLoading ? '提交中 ...' : '提 交'}}</el-button>
                                                    <el-button @click="modifyFlag = false" type="info">返 回</el-button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </el-scrollbar>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="创建试卷" name="second">
                        <div class="createPaperContainer">
                            <h1 class="createHeaderTitle">创建试卷</h1>
                            <div class="createContainer">
                                <el-scrollbar style="height:100%">        
                                    <table style="width: 850px"  class="createPaperTable">
                                        <tbody>
                                            <tr>
                                                <th>试卷名称</th>
                                                <td ><el-input  placeholder="请输入内容"   v-model="createPaperForm.paperName"   clearable></el-input></td>                                            
                                            </tr>
                                            <tr>
                                                <th>试卷信息</th>
                                                <td ><el-input  placeholder="请输入内容"   v-model="createPaperForm.paperMsg"   clearable></el-input></td>                                            
                                            </tr>
                                            <tr>
                                                <th>试卷总分</th>
                                                <td > 
                                                    <span>{{createPaperScore}} 分</span><span class="singAnswerTip">(该值自动计算，无需填写)</span>
                                                </td>
                                            </tr>                       
                                            <tr>
                                                <th style="min-width:120px">章节设置</th>
                                                <td>
                                                    <el-card class="articleCard">
                                                        <div slot="header" class="clearfix">
                                                            <span >{{singleSelect.partName}}（每题 <el-input-number v-model="singleSelect.questionScore" style="width:90px" size="mini"  controls-position="right"  :min="1" :max="99"></el-input-number>分）</span>
                                                            <div class="twoBtn">
                                                                <el-button type="text" @click="openAddRandomQuestion('单')">随机增加</el-button>
                                                                <span>/</span>
                                                                <el-button type="text" @click="openAddQuestionDialog('单')" style="color:#909399">手动增加</el-button>
                                                            </div>
                                                        </div>
                                                        <div class="selectBody" v-for="(item, i) in singleMultipleTable" :key="item.id" >
                                                            <div class="index_title">{{i+1}}.<div v-html="item.questionTitle" class="questionSpan"></div></div>
                                                            <div> 
                                                                <el-button @click="previewQuestion(item)" type="success" size="mini">预览</el-button>
                                                                <el-button @click="deleteSelectedQuestion(item, i)" type="danger" size="mini">删除</el-button>
                                                            </div>
                                                        </div>  
                                                    </el-card>    
                                                    <el-card class="articleCard">
                                                        <div slot="header" class="clearfix">
                                                            <span >{{multiSelect.partName}}（每题 <el-input-number v-model="multiSelect.questionScore" style="width:90px" size="mini"  controls-position="right"  :min="1" :max="99"></el-input-number>分）</span>
                                                            <div>
                                                                <el-button type="text" @click="openAddRandomQuestion('多')">随机增加</el-button>
                                                                <span>/</span>
                                                                <el-button type="text" @click="openAddQuestionDialog('多')" style="color:#909399">手动增加</el-button>
                                                            </div>
                                                            </div>
                                                        <div class="selectBody" v-for="(item, i) in moreMultipleTable" :key="item.id">
                                                            <div class="index_title">{{i+1}}.<div v-html="item.questionTitle" class="questionSpan"></div></div>
                                                            <div> 
                                                                <el-button @click="previewQuestion(item)" type="success" size="mini">预览</el-button>
                                                                <el-button @click="deleteSelectedQuestion(item, i)" type="danger" size="mini">删除</el-button>
                                                            </div>
                                                        </div>  
                                                    </el-card>
                                                    <el-card class="articleCard">
                                                        <div slot="header" class="clearfix">
                                                            <span >{{judgePart.partName}}（每题 <el-input-number v-model="judgePart.questionScore" style="width:90px" size="mini"  controls-position="right"  :min="1" :max="99"></el-input-number>分）</span>
                                                            <div>
                                                                <el-button type="text" @click="openAddRandomQuestion('判')">随机增加/</el-button>        
                                                                <span>/</span>
                                                                <el-button type="text" @click="openAddQuestionDialog('判')" style="color:#909399">手动增加</el-button>
                                                            </div>
                                                            </div>
                                                        <div class="selectBody" v-for="(item, i) in judgeMultipleTable" :key="item.id">
                                                            <div class="index_title">{{i+1}}.<div v-html="item.questionTitle" class="questionSpan"></div></div>
                                                            <div> 
                                                                <el-button @click="previewQuestion(item)" type="success" size="mini">预览</el-button>
                                                                <el-button @click="deleteSelectedQuestion(item, i)" type="danger" size="mini">删除</el-button>
                                                            </div>
                                                        </div>  
                                                    </el-card>
                                                    <el-card class="articleCard">
                                                        <div slot="header" class="clearfix">
                                                            <span >{{fillPart.partName}}（每题 <el-input-number v-model="fillPart.questionScore" style="width:90px" size="mini"  controls-position="right"  :min="1" :max="99"></el-input-number>分）</span>
                                                            <div>
                                                                <el-button type="text" @click="openAddRandomQuestion('填')">随机增加</el-button>        
                                                                <span>/</span>
                                                                <el-button type="text" @click="openAddQuestionDialog('填')" style="color:#909399">手动增加</el-button>
                                                            </div>
                                                            </div>
                                                        <div class="selectBody" v-for="(item, i) in fillMultipleTable" :key="item.id">
                                                            <div class="index_title">{{i+1}}.<div v-html="item.questionTitle" class="questionSpan"></div></div>
                                                            <div> 
                                                                <el-button @click="previewQuestion(item)" type="success" size="mini">预览</el-button>
                                                                <el-button @click="deleteSelectedQuestion(item, i)" type="danger" size="mini">删除</el-button>
                                                            </div>
                                                        </div>  
                                                    </el-card>
                                                    <el-card class="articleCard">
                                                        <div slot="header" class="clearfix">
                                                            <span >{{writePart.partName}}（每题 <el-input-number v-model="writePart.questionScore" style="width:90px" size="mini"  controls-position="right"  :min="1" :max="99"></el-input-number>分）</span>
                                                            <div>
                                                                <el-button type="text" @click="openAddRandomQuestion('简')">随机增加</el-button>
                                                                <span>/</span>
                                                                <el-button type="text" @click="openAddQuestionDialog('简')" style="color:#909399">手动增加</el-button>
                                                            </div>
                                                            </div>
                                                        <div class="selectBody" v-for="(item, i) in writeMultipleTable" :key="item.id">
                                                            <div class="index_title">{{i+1}}.<div v-html="item.questionTitle" class="questionSpan"></div></div>
                                                            <div> 
                                                                <el-button @click="previewQuestion(item)" type="success" size="mini">预览</el-button>
                                                                <el-button @click="deleteSelectedQuestion(item, i)" type="danger" size="mini">删除</el-button>
                                                            </div>
                                                        </div>  
                                                    </el-card>  
                                                    <el-card class="articleCard">
                                                        <div slot="header" class="clearfix">
                                                            <span >{{operatePart.partName}}（每题 <el-input-number v-model="operatePart.questionScore" style="width:90px" size="mini"  controls-position="right"  :min="1" :max="99"></el-input-number>分）</span>
                                                            <div>
                                                                <el-button type="text" @click="openAddRandomQuestion('实')">随机增加</el-button>
                                                                <span>/</span>
                                                                <el-button type="text" @click="openAddQuestionDialog('实')" style="color:#909399">手动增加</el-button>
                                                            </div>
                                                            </div>
                                                        <div class="selectBody" v-for="(item, i) in operateMultipleTable" :key="item.id">
                                                            <div class="index_title">{{i+1}}.<div v-html="item.questionTitle" class="questionSpan"></div></div>
                                                            <div> 
                                                                <el-button @click="previewQuestion(item)" type="success" size="mini">预览</el-button>
                                                                <el-button @click="deleteSelectedQuestion(item, i)" type="danger" size="mini">删除</el-button>
                                                            </div>
                                                        </div>  
                                                    </el-card>  
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>试卷及格分</th>
                                                <td ><el-input-number v-model="createPaperForm.passScore" controls-position="right"  :min="1" :max="createPaperScore"></el-input-number>
                                                </td> 
                                            </tr>
                                            <tr>
                                                <td colspan="2">
                                                    <el-button @click="submitCreateNewPaper()" type="success" style="width:250px;margin:20px 50px" :loading="submitLoading">{{submitLoading ? '提交中 ...' : '提 交'}}</el-button>
                                                    
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </el-scrollbar>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-card>
        <!-- 随机增加试题对话框-->
        <el-dialog width="500px" title="随机增加试题" top="120px" custom-class="addRandomQuesDialog"  
                :visible.sync="addRandomQuestionDV">
            <div class="bg">
                <div>
                    <span>试题科目：</span>
                    <el-select v-model="randomAddQuesParams.subjectId" placeholder="必选" class="addParam">
                        <el-option v-for="item in allSubjects" :label="item.subjectName"  :value="item.subjectId" :key="item.subjectId"></el-option>                 
                    </el-select>
                </div>
                <div>
                    <span>试题难度：</span>
                    <el-select v-model="randomAddQuesParams.questionDiff" placeholder="必选" class="addParam">
                        <el-option label="非常简单"  value="0"></el-option>   
                        <el-option label="简单"  value="1"></el-option>
                        <el-option label="中等"  value="2"></el-option>
                        <el-option label="较难"  value="3"></el-option>
                        <el-option label="非常难"  value="4"></el-option>              
                    </el-select>
                </div>
                <div>
                    <span>试题数量：</span>
                    <el-input-number v-model="randomAddQuesParams.randNumber"   controls-position="right"  :min="1" :max="99" class="addParam"></el-input-number>
                </div>
                <el-button type="warning" @click="addRandomQuestion()" class="btn">随机加入</el-button>
                <span class="tip">注：若试题数量大于库中数量，实际加入数量以库中数量为准。</span>
            </div>
        </el-dialog>
        <!-- 手动增加试题对话框-->
        <el-dialog width="1000px" title="增加试题" top="120px" custom-class="addQuesDialog"  
                :visible.sync="addQuestionDialogVisible">
            <div class="bg">
                <el-scrollbar style="height:100%">
                    <div class="search_div">
                        <div>
                            <el-input v-model="questionQueryParams.questionTitle" clearable placeholder="试题关键词" class="searchItem"></el-input>
                            <el-select v-model="questionQueryParams.questionDiff" @change="queryQuestionList()" clearable placeholder="试题难度" class="searchItem">
                                <el-option label="非常简单"  value="0"></el-option>   
                                <el-option label="简单"  value="1"></el-option>
                                <el-option label="中等"  value="2"></el-option>
                                <el-option label="较难"  value="3"></el-option>
                                <el-option label="非常难"  value="4"></el-option>              
                            </el-select>
                            <el-select v-model="questionQueryParams.subjectId" clearable placeholder="试题科目" @change="queryQuestionList()" class="searchItem">
                                <el-option v-for="item in allSubjects" :label="item.subjectName"  :value="item.subjectId" :key="item.subjectId"></el-option>                 
                            </el-select>
                            <el-button type="primary" @click="queryQuestionList()" class="searchItem">查询</el-button>
                        </div>
                        <el-button type="warning" @click="addSelectedQuestion()" >批量插入</el-button>
                    </div> 
                    <el-table :data="addQuestionsList" height="505px" stripe highlight-current-row  @selection-change="handleSelectionChange"
                                    :header-cell-style="{background:'#eef1f6',color:'#606266'}">  
                        <el-table-column type="selection" width="55" align="center"></el-table-column>  
                        <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>   
                        <el-table-column prop="questionTitle" label="试题题干" width="300"  align="center" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div v-html="scope.row.questionTitle"></div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="questionId" label="试题ID" v-if="false"></el-table-column>
                        <el-table-column prop="typeName" label="试题类型" v-if="false"></el-table-column>
                        <el-table-column prop="typeId" label="试题类型ID" v-if="false"></el-table-column>
                        <el-table-column prop="questionDiff" label="试题难度" v-if="false">
                            <template slot-scope="scope">
                                <span v-if="scope.row.questionDiff === '0'">{{'非常简单'}}</span>
                                <span v-else-if="scope.row.questionDiff === '1'">{{'简单'}}</span>
                                <span v-else-if="scope.row.questionDiff === '2'">{{'中等'}}</span>
                                <span v-else-if="scope.row.questionDiff === '3'">{{'较难'}}</span>
                                <span v-else-if="scope.row.questionDiff === '4'">{{'非常难'}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="questionOption" label="正确选项" width="100" align="center" ></el-table-column>                    
                        <el-table-column prop="optionStr" label="答案选项" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="questionAnswer" label="标准答案" align="center" show-overflow-tooltip> </el-table-column>
                        <el-table-column prop="questionAna" label="答案解析" v-if="false"> </el-table-column>                          
                        <el-table-column  label="操作" width="100"  align="center">
                            <template slot-scope="scope">
                                <el-button @click="previewQuestion(scope.row)" type="success" size="small">预览</el-button>
                            </template>
                    </el-table-column>
                    </el-table>         
                    <el-pagination @size-change="addQuestionSizeChange" @current-change="addQuestionCurrentChange" layout="total, sizes, prev, pager, next, jumper"
                        :current-page="questionQueryParams.pageNum" :page-sizes="[8, 16, 32]" class="pagin"
                        :page-size="questionQueryParams.pageSize" :total="addQustionTotalCount">
                        </el-pagination> 
                </el-scrollbar>
            </div>
            
        </el-dialog>
        <!-- 试题预览 -->
        <el-dialog width="800px" title="试题预览" :visible.sync="previewQuestionVisible" append-to-body>
            <div  class="quetionTable">
                <table class="quetionTable" width="100%" :data="previewQuestionTable">
                    <tbody>
                        <tr>
                            <th style="width:100px"><b>试题类型</b></th>
                            <td>{{previewQuestionTable.typeName}}</td>
                        </tr>
                        <tr>
                            <th><b>试题难度</b></th>
                            <td v-if="previewQuestionTable.questionDiff === '0'">非常简单</td>
                            <td v-else-if="previewQuestionTable.questionDiff === '1'">简单</td>
                            <td v-else-if="previewQuestionTable.questionDiff === '2'">中等</td>
                            <td v-else-if="previewQuestionTable.questionDiff === '3'">较难</td>
                            <td v-else-if="previewQuestionTable.questionDiff === '4'">非常难</td>
                        </tr>
                        <tr>
                            <th><b>试题题干</b></th>
                            <td>
                                <div v-html="previewQuestionTable.questionTitle"></div>
                            </td>
                        </tr>                        
                        <tr v-show="previewAnswerItemHiddenFlag">
                            <th ><b>选项设置</b></th>
                            <td>
                                <table class="answersTable" width="100%" >
                                    <tbody>
                                        <tr v-for="item in previewQuestionTable.options" :key="item.optionId">
                                            <th >
                                                <b >{{item.optionValue}}</b>
                                            </th>
                                            <td>
                                                {{item.optionLabel}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <th ><b>正确答案</b></th>
                            <td>{{previewAnswerItemHiddenFlag ? previewQuestionTable.questionOption : previewQuestionTable.questionAnswer}}</td>
                        </tr>
                        <tr>
                            <th >
                                <b>答案解析</b>
                            </th>
                            <td>{{previewQuestionTable.questionAna}}</td>
                        </tr>
                    </tbody>
                </table>  
            </div>          
        </el-dialog>
        <!-- 预览试卷对话框-->
        <el-dialog width="1200px" top="10px" :visible.sync="previewPaperDialogVisible">
            <div slot="title" >
                <span >试卷预览</span>
            </div>
            <div style="height:800px">
                <el-scrollbar style="height:100%">
                    <table class="quetionTable" width="100%" :data="previewTable">
                        <tbody>
                            <tr>
                                <th style="width:100px"><b>试卷名称</b></th>
                                <td>{{previewTable.paperName}}</td>
                            </tr>
                            <tr>
                                <th><b>试卷章节</b></th>
                                <td>
                                    <div v-for="item in previewTable.examPartList" :key="item.partName">
                                        <div class="singleArticle" >
                                            <div class="articleName">{{item.partName}}</div>
                                            <el-table class="questionsDiv"  :data="item.questions" max-height="350px" :header-cell-style="{height:'10px',background:'#eef1f6',color:'#606266'}">
                                                <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                                                <el-table-column prop="questionTitle" label="试题题干" align="center" show-overflow-tooltip>
                                                    <template slot-scope="scope">
                                                        <div v-html="scope.row.questionTitle"></div>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="optionStr" label="答案选项" align="center" show-overflow-tooltip></el-table-column>            
                                                <el-table-column prop="questionOption" label="正确选项" width="100" align="center" ></el-table-column>  
                                                <el-table-column prop="questionAnswer" label="标准答案(主观题)" width="250" align="center" show-overflow-tooltip> </el-table-column>                                          
                                            </el-table>
                                        </div>
                                    </div>
                                </td>
                            </tr>                       
                        </tbody>
                    </table>  
                </el-scrollbar>
            </div>
        </el-dialog>
        <!-- 复制试卷-->
        <el-dialog width="800px" top="10px" :visible.sync="copyDialogVisible">
            <div slot="title" >
                <span >复制试卷</span>
            </div>
            <el-tooltip effect="dark" content="可点击复制" placement="right">
                <div  class="copyPaper" id="copyDiv" @click="copy">
                    <el-scrollbar style="height:100%">
                        <h1>{{copyPaperTable.paperName}}</h1>
                        <div class="exam_question" v-for="part in copyPaperTable.examPartList" :key="part.partId">
                            <div >
                                <span class="partName"><b>{{part.partName}}</b></span>
                            </div>
                            <div v-for="(ques, index) in part.questions" :key="ques.questionId" class="partBody">
                                <div v-if="part.partName.indexOf('单') != -1 || part.partName.indexOf('多') != -1" class="ques_div">
                                    <div class="left">
                                        <div>{{index + 1 + '.'}}</div><div v-html="ques.questionTitle"></div>
                                    </div>
                                    <div class="right">
                                        (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
                                    </div>
                                </div>
                                <!-- <tr  v-if="part.partName.indexOf('单') != -1">
                                    <td>{{ques.options[0].optionValue + '.'}}{{ques.options[0].optionLabel}}</td>
                                    <td>{{ques.options[1].optionValue + '.'}}{{ques.options[1].optionLabel}}</td>
                                </tr>
                                <tr  v-if="part.partName.indexOf('单') != -1">
                                    <td>{{ques.options[2].optionValue + '.'}}{{ques.options[2].optionLabel}}</td>
                                    <td>{{ques.options[3].optionValue + '.'}}{{ques.options[3].optionLabel}}</td>
                                </tr> -->
                                <div v-if="part.partName.indexOf('多') != -1 || part.partName.indexOf('单') != -1" class="optionTr">
                                    <span v-for="item in ques.options" :key="item.optionId">{{item.optionValue + '.'}}{{item.optionLabel}}</span>
                                </div>
                                <div v-if="part.partName.indexOf('判') != -1" class="ques_div">
                                    <div class="left">
                                        <div>{{index + 1 + '.'}}</div><div v-html="ques.questionTitle"></div>
                                    </div>
                                    <div class="right">
                                        (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
                                    </div>
                                </div>
                                <div v-if="part.partName.indexOf('填') != -1" class="left">
                                    <div>{{index + 1 + '.'}}</div><div v-html="ques.questionTitle"></div>
                                </div>
                                <div v-if="part.partName.indexOf('简') != -1" class="left jdsc">
                                    <div>{{index + 1 + '.'}} </div><div v-html="ques.questionTitle"></div>
                                </div><div v-if="part.partName.indexOf('实') != -1" class="left jdsc">
                                    <div>{{index + 1 + '.'}} </div><div v-html="ques.questionTitle"></div>
                                </div>
                            </div>
                        </div>
                    </el-scrollbar><!-- <el-button @click="copy">默认按钮</el-button> -->
                </div>
            
            </el-tooltip>
        </el-dialog>
    </div>  
</template>

<script>
import {queryQuestionList,addQuestion,modifyQuestion, queryQuestionTypeList, addQuestionType, modifyQuestionType,queryAllSubjects,randomQues } from '../../api/question'
import {queryExamPaperList,queryExamPaperById,addPaper,modifyPaper,deleteExamPapers } from '../../api/examPaper'
export default {
    data() {
        return {
            activeName:'first',                     //el-tab-pane首选页面
            submitLoading:false,
            paperQueryParams: {                     //试卷管理-查询参数
                paperId: null,
                paperName: null,
                paperScore:null,
                createBy:null,
                createTime:null,
                state: '1',
                pageNum: 1,
                pageSize:10,
            }, 
            allSubjects:[],
            paperTotalCount: 0,                     //试卷管理-试卷数据总条数
            paperList: [],                          //试卷管理-表格数据
            paperSwitchValue:true,                  //试卷管理-试卷状态开关
            previewPaperDialogVisible:false,        //试卷管理-预览试卷对话框显示标志
            previewTable:{},                        //试卷管理-预览试卷表格数据
            questionTypeQueryParams: {              //试题类型-查询参数
                state: '1',
            },
            questionTypeList:[],                    //试题类型  
            questionQueryParams: {                  //手动增加试题-查询参数
                questionId: null,
                questionTitle: null,
                questionDiff:null,
                typeId:'',
                state: '1',
                pageNum: 1,
                pageSize:8,
            }, 
            randomAddQuesParams: {                  //随机增加试题参数
                subjectId:null,
                state: '1',
                typeId:'',
                randNumber:null,
                questionDiff:null
            }, 
            addQustionTotalCount:0,
            singleSelect:{                          //创建试卷-单选题
                partName:'单选题',                      
                questionScore: 1,
                questionIds:[],
            },                       
            multiSelect:{
                partName:'多选题',                      
                questionScore: 1,
                questionIds:[],
            },     
            judgePart:{
                partName:'判断题',                      
                questionScore: 1,
                questionIds:[],
            },
            fillPart:{
                partName:'填空题',                      
                questionScore: 1,
                questionIds:[],
            },                            
            writePart:{
                partName:'简答题',                      
                questionScore: 1,
                questionIds:[],
            },
            operatePart:{
                partName:'实操题',                      
                questionScore: 1,
                questionIds:[],
            },
            addQuestionsList:[],
            previewQuestionVisible:false,
            previewQuestionTable:{},
            selectedQuestions:[],               //增加试题对话框选择的试题数组
            singleMultipleTable:[],             //单选增加试题所批量选择的试题
            moreMultipleTable:[],               //多选增加试题所批量选择的试题
            judgeMultipleTable:[],              //判断增加试题所批量选择的试题
            fillMultipleTable:[],               //填空增加试题所批量选择的试题
            writeMultipleTable:[],              //简答增加试题所批量选择的试题
            operateMultipleTable:[],              //实操增加试题所批量选择的试题    
            addQuestionDialogVisible:false,         //章节增加试题对话框显示标志
            addQuestionspaperList:[],           //增加试题对话框表格数据
            previewAnswerItemHiddenFlag:true,
            modifyFlag:false,                   //编辑界面显示标志
            createPaperForm:{
                examPartList:[],
            },              //新建试卷表单
            modfiyPaperForm:{
                examPartList:[],
            },              //修改试卷表单    
            addRandomQuestionDV:false,
            copyDialogVisible:false,
            copyPaperTable:{},
            multipleSelection:[]
        };
    },
    watch:{
        paperSwitchValue: function(newSwitchValue, oldSwitchValue){
            if(newSwitchValue === true){
                this.paperQueryParams.state = '1';
            }else {
                this.paperQueryParams.state = '0';
            }
            this.queryExamPapers();
        },
    },
    computed:{
        //试卷总分
        createPaperScore: function(){
            return this.singleMultipleTable.length * this.singleSelect.questionScore + this.moreMultipleTable.length * this.multiSelect.questionScore +
                this.judgeMultipleTable.length * this.judgePart.questionScore + this.fillMultipleTable.length * this.fillPart.questionScore +
               this.writeMultipleTable.length * this.writePart.questionScore + this.operateMultipleTable.length * this.operatePart.questionScore
        },
        modfiyPaperScore: function(){
            return this.singleMultipleTable.length * this.singleSelect.questionScore + this.moreMultipleTable.length * this.multiSelect.questionScore +
                this.judgeMultipleTable.length * this.judgePart.questionScore + this.fillMultipleTable.length * this.fillPart.questionScore +
               this.writeMultipleTable.length * this.writePart.questionScore + this.operateMultipleTable.length * this.operatePart.questionScore
        }
    },
    created(){
        //this.queryQuestionTypeList();
        // this.queryExamPapers();
        // this.queryAllSubjects()
    },
    mounted(){
        this.queryExamPapers();
        this.queryQuestionTypeList();
        this.queryAllSubjects();
    },
    methods: { 
        //查询试题类型
        queryQuestionTypeList(){
            queryQuestionTypeList(this.questionTypeQueryParams).then(res => {
                if(res.data.code === 200) {
                    this.questionTypeList = res.data.data;
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })
        }, 
        //试卷管理-查询所有考试
        queryExamPapers(){
            queryExamPaperList(this.paperQueryParams).then(res => {
                if(res.data.code === 200) {
                    this.paperList = res.data.rows;
                    this.paperTotalCount =  res.data.total;
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })
        }, 
        //批量选择
        selectPapersChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection);
        },
        //批量删除
        deleteSelectedPapers(){
            if(this.multipleSelection.length <= 0){
                this.sendMsg("您未选择任何试卷，无法删除！", "warning");
                return
            }
            let paperIds= [];
            this.multipleSelection.forEach(item => {
                paperIds.push(item.paperId);
            })
            this.$confirm("此操作将永久删除所选试卷, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                deleteExamPapers(paperIds).then(res => {
                    console.log(res);
                    if (res.data.code === 200) {
                        this.sendMsg("删除成功", "success");
                        this.queryExamPapers();
                    }else {
                        this.sendMsg(res.data.msg, "error");
                    }
                })
            });
        },
        //试卷管理-改变当前记录条数
        paperSizeChange(val) {
            this.paperQueryParams.pageSize = val;
            this.paperQueryParams.pageNum =1;
            this.queryExamPapers();
        },
        //试卷管理-改变当前页码
        paperCurrentChange(val) {
            this.paperQueryParams.pageNum =val;
            this.queryExamPapers();
        },
        //试卷管理-预览试卷
        previewPaper(row){
            this.previewPaperDialogVisible = true;
            //根据paperId查询试卷具体信息
            let paperId = row.paperId;
            queryExamPaperById(paperId).then(res => {
                console.log(res);
                if(res.data.code === 200) {
                    this.previewTable = res.data.data;
                    for(let i = 0; i < this.previewTable.examPartList.length;i++){
                        for(let j = 0; j < this.previewTable.examPartList[i].questions.length;j++){
                            let typeName = this.previewTable.examPartList[i].questions[j].typeName;
                            if(typeName.indexOf('填') === -1 && typeName.indexOf('简') === -1 && typeName.indexOf('实') === -1){              
                                let questionOptionStr = "";
                                for(let k = 0; k < this.previewTable.examPartList[i].questions[j].options.length; k++){
                                    questionOptionStr = questionOptionStr + this.previewTable.examPartList[i].questions[j].options[k].optionValue + '.' + this.previewTable.examPartList[i].questions[j].options[k].optionLabel + ";";
                                }
                                this.previewTable.examPartList[i].questions[j].optionStr = questionOptionStr;
                            }
                        }
                    }
                    const temp = [];
                    for(let i = 0; i < this.previewTable.examPartList.length;i++){
                        if(this.previewTable.examPartList[i].partName.indexOf('单') != -1){
                            temp.push(this.previewTable.examPartList[i]);
                        }
                    }
                    for(let i = 0; i < this.previewTable.examPartList.length;i++){
                        if(this.previewTable.examPartList[i].partName.indexOf('多') != -1){
                            temp.push(this.previewTable.examPartList[i]);
                        }
                    }
                    for(let i = 0; i < this.previewTable.examPartList.length;i++){
                        if(this.previewTable.examPartList[i].partName.indexOf('判') != -1){
                            temp.push(this.previewTable.examPartList[i]);
                        }
                    }
                    for(let i = 0; i < this.previewTable.examPartList.length;i++){
                        if(this.previewTable.examPartList[i].partName.indexOf('填') != -1){
                            temp.push(this.previewTable.examPartList[i]);
                        }
                    }
                    for(let i = 0; i < this.previewTable.examPartList.length;i++){
                        if(this.previewTable.examPartList[i].partName.indexOf('简') != -1){
                            temp.push(this.previewTable.examPartList[i]);
                        }
                    }
                    for(let i = 0; i < this.previewTable.examPartList.length;i++){
                        if(this.previewTable.examPartList[i].partName.indexOf('实') != -1){
                            temp.push(this.previewTable.examPartList[i]);
                        }
                    }
                    this.previewTable.examPartList = temp;
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            }) 
                
        },
        copyPaper(row){
            this.copyDialogVisible = true;
            //根据paperId查询试卷具体信息
            let paperId = row.paperId;
            queryExamPaperById(paperId).then(res => {
                if(res.data.code === 200) {
                    this.copyPaperTable = res.data.data;
                }
                    
            }) 
        } , 
        copy() {
            const table = document.getElementById('copyDiv')
            const range = document.createRange()
            // 设定range包含的节点对象 
            range.selectNode(table)
            // 窗口的selection对象，表示用户选择的文本
            const selection = window.getSelection()
            // 将已经包含的已选择的对象清除掉
            if (selection.rangeCount > 0) selection.removeAllRanges()
            // 将要复制的区域的range对象添加到selection对象中
            selection.addRange(range)
            // 执行copy命令，copy用户选择的文本
            document.execCommand('copy')

             this.$message({
                message: '已复制！',
                type: 'success'
            }); 
        },

        //创建试卷-打开手动增加试题对话框
        openAddQuestionDialog(val){
            this.addQuestionDialogVisible = true;
            let typeId = '';
            for(let i =0; i< this.questionTypeList.length;i++){
                if(this.questionTypeList[i].typeName.indexOf(val) != -1){
                    typeId = this.questionTypeList[i].typeId;
                }
            }
            this.questionQueryParams.pageNum = 1;
            this.questionQueryParams.pageSize =8;
            this.questionQueryParams.typeId = typeId;
            this.queryQuestionList();
        }, 
        //创建试卷-打开随机增加试题对话框
        openAddRandomQuestion(val){
            this.addRandomQuestionDV = true;
            let typeId = '';
            for(let i =0; i< this.questionTypeList.length;i++){
                if(this.questionTypeList[i].typeName.indexOf(val) != -1){
                    typeId = this.questionTypeList[i].typeId;
                }
            }
            this.randomAddQuesParams.typeId = typeId;
        }, 
        //查询所有科目
        queryAllSubjects(){
            queryAllSubjects({state:'1'}).then(res => {
                if(res.data.code === 200) {
                    this.allSubjects = res.data.data;
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })
        },
         
        //查询试题
        queryQuestionList(){
            queryQuestionList(this.questionQueryParams).then(res => {
                if(res.data.code === 200) {
                    this.addQuestionsList = res.data.rows;
                    //重组答案选项             
                    for(let i = 0; i < this.addQuestionsList.length;i++){
                        if(this.addQuestionsList[i].typeName.indexOf('填') ===  -1 && this.addQuestionsList[i].typeName.indexOf('实') ===  -1 && this.addQuestionsList[i].typeName.indexOf('判') ===  -1){
                            let questionOptionStr = "";
                            for(let j = 0; j < this.addQuestionsList[i].options.length; j++){
                                questionOptionStr = questionOptionStr + this.addQuestionsList[i].options[j].optionValue + '.' + this.addQuestionsList[i].options[j].optionLabel + ";";
                            }
                            this.addQuestionsList[i].optionStr = questionOptionStr;
                        }
                    }
                    this.addQustionTotalCount =  res.data.total;
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })
        },
        //增加试题-改变当前记录条数
        addQuestionSizeChange(val) {
            this.questionQueryParams.pageSize = val;
            this.questionQueryParams.pageNum =1;
            this.queryQuestionList();
        },
        //增加试题-改变当前页码
        addQuestionCurrentChange(val) {
            this.questionQueryParams.pageNum =val;
            this.queryQuestionList();
        },
        //增加试题-预览试题
        previewQuestion(row){
            this.previewQuestionVisible = true;
            this.previewQuestionTable = {
                typeName : row.typeName,
                questionDiff : row.questionDiff,
                questionTitle: row.questionTitle,
                questionOption: row.questionOption,
                questionAnswer: row.questionAnswer,
                options: row.options,
                questionAna: row.questionAna
            }
            //判断是否为填空题
            if(row.typeName.indexOf('填') != -1 || row.typeName.indexOf('简') != -1 || row.typeName.indexOf('实') != -1 ) {
                this.previewAnswerItemHiddenFlag = false;//隐藏此Tr
            }else {
                //分割选项
                this.previewAnswerItemHiddenFlag = true;
            }
        },
        //创建考试提交
        submitCreateNewPaper(){
            const result = this.judgeCreatePaper();
            if(!result.value){
                this.$message({
                    message: result.msg,
                    type: 'warning'
                }); 
                return
            }else {
                this.submitLoading = true;
                //组装数据
                const loginInfo = JSON.parse(this.$store.state.loginInfo);
                this.createPaperForm.createBy = loginInfo.userName;
                this.createPaperForm.createName = loginInfo.relayName;
                this.createPaperForm.examPartList = [];
                this.createPaperForm.paperScore = this.createPaperScore;
                
                //单选
                const singleExamPart = {
                    partName: this.singleSelect.partName,
                    sort: 0,
                    questionScore: this.singleSelect.questionScore,
                    questionIds:[]
                }
                if(this.singleMultipleTable.length >0){
                    this.singleMultipleTable.forEach(item =>{
                        singleExamPart.questionIds.push(item.questionId);
                    })
                }
                this.createPaperForm.examPartList.push(singleExamPart);
                //多选
                const moreExamPart = {
                    partName: this.multiSelect.partName,
                    sort: 1,
                    questionScore: this.multiSelect.questionScore,
                    questionIds:[]
                }
                if(this.moreMultipleTable.length >0){
                    this.moreMultipleTable.forEach(item =>{
                        moreExamPart.questionIds.push(item.questionId);
                    })
                }
                this.createPaperForm.examPartList.push(moreExamPart);
                 //判断
                const judgeExamPart = {
                    partName: this.judgePart.partName,
                    sort: 2,
                    questionScore: this.judgePart.questionScore,
                    questionIds:[]
                }
                if(this.judgeMultipleTable.length >0){
                    this.judgeMultipleTable.forEach(item =>{
                        judgeExamPart.questionIds.push(item.questionId);
                    })
                }
                this.createPaperForm.examPartList.push(judgeExamPart);
                //填空
                const fillExamPart = {
                    partName: this.fillPart.partName,
                    sort: 3,
                    questionScore: this.fillPart.questionScore,
                    questionIds:[]
                }
                if(this.fillMultipleTable.length >0){
                    this.fillMultipleTable.forEach(item =>{
                        fillExamPart.questionIds.push(item.questionId);
                    })
                }
                this.createPaperForm.examPartList.push(fillExamPart);
                //简答
                const writeExamPart = {
                    partName: this.writePart.partName,
                    sort: 4,
                    questionScore: this.writePart.questionScore,
                    questionIds:[]
                }
                if(this.writeMultipleTable.length >0){
                    this.writeMultipleTable.forEach(item =>{
                        writeExamPart.questionIds.push(item.questionId);
                    })
                }
                this.createPaperForm.examPartList.push(writeExamPart);
                //实操
                const operateExamPart = {
                    partName: this.operatePart.partName,
                    sort: 5,
                    questionScore: this.operatePart.questionScore,
                    questionIds:[]
                }
                if(this.operateMultipleTable.length >0){
                    this.operateMultipleTable.forEach(item =>{
                        operateExamPart.questionIds.push(item.questionId);
                    })
                }
                this.createPaperForm.examPartList.push(operateExamPart);
                const temp = [];
                for(let i = 0;i < this.createPaperForm.examPartList.length;i++){
                    if(this.createPaperForm.examPartList[i].questionIds.length > 0){
                        temp.push(this.createPaperForm.examPartList[i]);
                    }
                }
                for(let i = 0; i < temp.length;i++){
                    if(i === 0){
                        temp[i].partName = '一、'+temp[i].partName;
                    }else if(i === 1){
                        temp[i].partName = '二、'+temp[i].partName;
                    }else if(i === 2){
                        temp[i].partName = '三、'+temp[i].partName;
                    }else if(i === 3){
                        temp[i].partName = '四、'+temp[i].partName;
                    }else if(i === 4){
                        temp[i].partName = '五、'+temp[i].partName;
                    }else if(i === 5){
                        temp[i].partName = '六、'+temp[i].partName;
                    }
                }
                this.createPaperForm.examPartList = temp;    
                addPaper(this.createPaperForm).then(res => {
                    this.submitLoading = false;
                    if(res.data.code === 200) {
                        this.$message({
                            message: '成功创建试卷',
                            type: 'success'
                        }); 
                        this.createPaperForm = {
                            examPartList:[],
                        };
                        this.singleMultipleTable = [];
                        this.moreMultipleTable = [];
                        this.fillMultipleTable = [];
                        this.judgeMultipleTable = [];
                        this.writeMultipleTable = [];
                        this.operateMultipleTable = [];
                        
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: 'error'
                        });   
                    }
                })
            }
        },  
        //修改提交
        submitModifyPaper(){
            const result = this.judgeModifyPaper();
            if(!result.value){
                this.$message({
                    message: result.msg,
                    type: 'warning'
                }); 
                return
            }else {
                this.submitLoading = true;
                //组装数据
                this.modfiyPaperForm.examPartList = [];
                this.modfiyPaperForm.paperScore = this.modfiyPaperScore;
                
                //单选
                const singleExamPart = {
                    partName: this.singleSelect.partName,
                    sort: 0,
                    questionScore: this.singleSelect.questionScore,
                    questionIds:[]
                }
                if(this.singleMultipleTable.length >0){
                    this.singleMultipleTable.forEach(item =>{
                        singleExamPart.questionIds.push(item.questionId);
                    })
                }
                this.modfiyPaperForm.examPartList.push(singleExamPart);
                //多选
                const moreExamPart = {
                    partName: this.multiSelect.partName,
                    sort: 1,
                    questionScore: this.multiSelect.questionScore,
                    questionIds:[]
                }
                if(this.moreMultipleTable.length >0){
                    this.moreMultipleTable.forEach(item =>{
                        moreExamPart.questionIds.push(item.questionId);
                    })
                }
                this.modfiyPaperForm.examPartList.push(moreExamPart);
                 //判断
                const judgeExamPart = {
                    partName: this.judgePart.partName,
                    sort: 2,
                    questionScore: this.judgePart.questionScore,
                    questionIds:[]
                }
                if(this.judgeMultipleTable.length >0){
                    this.judgeMultipleTable.forEach(item =>{
                        judgeExamPart.questionIds.push(item.questionId);
                    })
                }
                this.modfiyPaperForm.examPartList.push(judgeExamPart);
                //填空
                const fillExamPart = {
                    partName: this.fillPart.partName,
                    sort: 3,
                    questionScore: this.fillPart.questionScore,
                    questionIds:[]
                }
                if(this.fillMultipleTable.length >0){
                    this.fillMultipleTable.forEach(item =>{
                        fillExamPart.questionIds.push(item.questionId);
                    })
                }
                this.modfiyPaperForm.examPartList.push(fillExamPart);
                //简答
                const writeExamPart = {
                    partName: this.writePart.partName,
                    sort: 4,
                    questionScore: this.writePart.questionScore,
                    questionIds:[]
                }
                if(this.writeMultipleTable.length >0){
                    this.writeMultipleTable.forEach(item =>{
                        writeExamPart.questionIds.push(item.questionId);
                    })
                }
                this.modfiyPaperForm.examPartList.push(writeExamPart);
                //实操
                const operateExamPart = {
                    partName: this.operatePart.partName,
                    sort: 5,
                    questionScore: this.operatePart.questionScore,
                    questionIds:[]
                }
                if(this.operateMultipleTable.length >0){
                    this.operateMultipleTable.forEach(item =>{
                        operateExamPart.questionIds.push(item.questionId);
                    })
                }
                this.modfiyPaperForm.examPartList.push(operateExamPart);
                const temp = [];
                for(let i = 0;i < this.modfiyPaperForm.examPartList.length;i++){
                    if(this.modfiyPaperForm.examPartList[i].questionIds.length > 0){
                        temp.push(this.modfiyPaperForm.examPartList[i]);
                    }
                }
                for(let i = 0; i < temp.length;i++){
                    if(i === 0){
                        temp[i].partName = '一、'+temp[i].partName;
                    }else if(i === 1){
                        temp[i].partName = '二、'+temp[i].partName;
                    }else if(i === 2){
                        temp[i].partName = '三、'+temp[i].partName;
                    }else if(i === 3){
                        temp[i].partName = '四、'+temp[i].partName;
                    }else if(i === 4){
                        temp[i].partName = '五、'+temp[i].partName;
                    }else if(i === 5){
                        temp[i].partName = '六、'+temp[i].partName;
                    }
                }
                this.modfiyPaperForm.examPartList = temp;           
                modifyPaper(this.modfiyPaperForm).then(res => {
                    this.submitLoading = false;
                    if(res.data.code === 200) {
                        this.$message({
                            message: '成功修改试卷',
                            type: 'success'
                        }); 
                        this.modfiyPaperForm = {
                            examPartList:[],
                        };
                        this.modifyFlag = false;
                        this.queryExamPapers();
                        this.singleMultipleTable = [];
                        this.moreMultipleTable = [];
                        this.fillMultipleTable = [];
                        this.judgeMultipleTable = [];
                        this.writeMultipleTable = [];
                        this.operateMultipleTable = []
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: 'error'
                        });   
                    }
                })
            }
        },
        //判断试卷(创建)填写情况  
        judgeCreatePaper(){
            let result = {
                msg:'',
                value:true
            };
            if(['',undefined,null].includes(this.createPaperForm.paperName)){
                result.value = false;
                result.msg = '试卷名称不能为空！';
                return result
            }
            if(['',undefined,null].includes(this.createPaperForm.paperMsg)){
                result.value = false;
                result.msg = '试卷信息不能为空！';
                return result
            }
            if(this.singleMultipleTable.length <= 0 && this.moreMultipleTable.length <=0 && this.judgeMultipleTable.length <=0 &&
                this.fillMultipleTable.length <= 0 && this.writeMultipleTable.length <= 0 && this.operateMultipleTable.length <= 0){
                result.value = false;
                result.msg = '章节内没有试题，请先添加';
                return result        
            }
            if(['',undefined,null].includes(this.createPaperForm.passScore)){
                result.value = false;
                result.msg = '试卷及格分不能为空！';
                return result
            }
            return result
        },
        //判断试卷(修改)填写情况
        judgeModifyPaper(){
            let result = {
                msg:'',
                value:true
            };
            if(['',undefined,null].includes(this.modfiyPaperForm.paperMsg)){
                result.value = false;
                result.msg = '试卷信息不能为空！';
                return result
            }
            if(this.singleMultipleTable.length <= 0 && this.moreMultipleTable.length <=0 && this.judgeMultipleTable.length <=0 &&
                this.fillMultipleTable.length <= 0 && this.writeMultipleTable.length <= 0 && this.operateMultipleTable.length <= 0){
                result.value = false;
                result.msg = '章节内没有试题，请先添加';
                return result        
            }
            if(['',undefined,null].includes(this.modfiyPaperForm.passScore)){
                result.value = false;
                result.msg = '试卷及格分不能为空！';
                return result
            }
            if(this.modfiyPaperForm.passScore > this.modfiyPaperScore){
                result.value = false;
                result.msg = '试卷及格分不能大于总分！';
                return result
            }
            return result
        },
        //批量选择试题
        handleSelectionChange(val) {
            this.selectedQuestions = val;
        },
        //手动批量加入试题
        addSelectedQuestion(){
            //判断是否选择题目
            if(this.selectedQuestions.length === 0){
                this.$message({
                    message: '您未勾选任何题目，请先勾选！',
                    type: 'warning'
                });
                return
            }
            //加入试题前进行判断
            let typeName = this.selectedQuestions[0].typeName;
            if(typeName.indexOf('单') != -1){
                if(this.singleMultipleTable.length === 0){
                    //如果未添加任何题目，则直接赋值
                     this.singleMultipleTable= this.selectedQuestions;
                }else {
                    let result = []
                    for (let i = 0; i < this.selectedQuestions.length; i++) {
                        let obj = this.selectedQuestions[i]
                        let num = obj.questionId;
                        let isExist = false
                        for (let j = 0; j < this.singleMultipleTable.length; j++) {
                            let aj = this.singleMultipleTable[j]
                            let n = aj.questionId
                            if (n === num) {
                                isExist = true
                                break
                            }
                        }
                        if (!isExist) {
                            result.push(obj)
                        }
                    }
                    if(result.length != 0){
                        result.forEach((multiItem,multiIndex) => {
                            this.singleMultipleTable.push(multiItem)
                        })
                    }
                }
            }else if(typeName.indexOf('多') != -1){
                if(this.moreMultipleTable.length === 0){
                    //如果未添加任何题目，则直接赋值
                     this.moreMultipleTable= this.selectedQuestions;
                }else {
                    let result = []
                    for (let i = 0; i < this.selectedQuestions.length; i++) {
                        let obj = this.selectedQuestions[i]
                        let num = obj.questionId;
                        let isExist = false
                        for (let j = 0; j < this.moreMultipleTable.length; j++) {
                            let aj = this.moreMultipleTable[j]
                            let n = aj.questionId
                            if (n === num) {
                                isExist = true
                                break
                            }
                        }
                        if (!isExist) {
                            result.push(obj)
                        }
                    }
                    if(result.length != 0){
                        result.forEach((multiItem,multiIndex) => {
                            this.moreMultipleTable.push(multiItem)
                        })
                    }
                }
            }else if(typeName.indexOf('判') != -1){
                if(this.judgeMultipleTable.length === 0){
                    //如果未添加任何题目，则直接赋值
                     this.judgeMultipleTable= this.selectedQuestions;
                }else {
                    let result = []
                    for (let i = 0; i < this.selectedQuestions.length; i++) {
                        let obj = this.selectedQuestions[i]
                        let num = obj.questionId;
                        let isExist = false
                        for (let j = 0; j < this.judgeMultipleTable.length; j++) {
                            let aj = this.judgeMultipleTable[j]
                            let n = aj.questionId
                            if (n === num) {
                                isExist = true
                                break
                            }
                        }
                        if (!isExist) {
                            result.push(obj)
                        }
                    }
                    if(result.length != 0){
                        result.forEach((multiItem,multiIndex) => {
                            this.judgeMultipleTable.push(multiItem)
                        })
                    }
                }
            }else if(typeName.indexOf('填') != -1){
                if(this.fillMultipleTable.length === 0){
                    //如果未添加任何题目，则直接赋值
                     this.fillMultipleTable= this.selectedQuestions;
                }else {
                    let result = []
                    for (let i = 0; i < this.selectedQuestions.length; i++) {
                        let obj = this.selectedQuestions[i]
                        let num = obj.questionId;
                        let isExist = false
                        for (let j = 0; j < this.fillMultipleTable.length; j++) {
                            let aj = this.fillMultipleTable[j]
                            let n = aj.questionId
                            if (n === num) {
                                isExist = true
                                break
                            }
                        }
                        if (!isExist) {
                            result.push(obj)
                        }
                    }
                    if(result.length != 0){
                        result.forEach((multiItem,multiIndex) => {
                            this.fillMultipleTable.push(multiItem)
                        })
                    }

                }
            }else if(typeName.indexOf('简') != -1){
                if(this.writeMultipleTable.length === 0){
                    //如果未添加任何题目，则直接赋值
                     this.writeMultipleTable= this.selectedQuestions;
                }else {
                     let result = []
                    for (let i = 0; i < this.selectedQuestions.length; i++) {
                        let obj = this.selectedQuestions[i]
                        let num = obj.questionId;
                        let isExist = false
                        for (let j = 0; j < this.writeMultipleTable.length; j++) {
                            let aj = this.writeMultipleTable[j]
                            let n = aj.questionId
                            if (n === num) {
                                isExist = true
                                break
                            }
                        }
                        if (!isExist) {
                            result.push(obj)
                        }
                    }
                    if(result.length != 0){
                        result.forEach((multiItem,multiIndex) => {
                            this.writeMultipleTable.push(multiItem)
                        })
                    }
                }
            }else if(typeName.indexOf('实') != -1){
                if(this.operateMultipleTable.length === 0){
                    //如果未添加任何题目，则直接赋值
                     this.operateMultipleTable= this.selectedQuestions;
                }else {
                     let result = []
                    for (let i = 0; i < this.selectedQuestions.length; i++) {
                        let obj = this.selectedQuestions[i]
                        let num = obj.questionId;
                        let isExist = false
                        for (let j = 0; j < this.operateMultipleTable.length; j++) {
                            let aj = this.operateMultipleTable[j]
                            let n = aj.questionId
                            if (n === num) {
                                isExist = true
                                break
                            }
                        }
                        if (!isExist) {
                            result.push(obj)
                        }
                    }
                    if(result.length != 0){
                        result.forEach((multiItem,multiIndex) => {
                            this.operateMultipleTable.push(multiItem)
                        })
                    }
                }
            }
            this.$message({
                message: '已批量加入！',
                type: 'success'
            });
        },
        //随机加入试题
        addRandomQuestion(){
            if(['',null,undefined].indexOf(this.randomAddQuesParams.subjectId) != -1){
                this.$message({
                    message: '请选择试题科目后提交！',
                    type: 'warning'
                });
                return
            }
            if(['',null,undefined].indexOf(this.randomAddQuesParams.questionDiff) != -1){
                this.$message({
                    message: '请选择试题难度后提交！',
                    type: 'warning'
                });
                return
            }
            randomQues(JSON.stringify(this.randomAddQuesParams)).then(res => {
                //console.log(res);
                if(res.data.code === 200) {
                    const quesArr = res.data.data ? res.data.data :[];
                    console.log(quesArr);
                    if(quesArr.length == 0){
                        this.$message({
                            message: '库中未含有此类试题，请尝试更换试题科目或难度，也可去试题管理页面添加！',
                            type: 'warning'
                        });
                    }else {
                        let typeName = quesArr[0].typeName;
                        let questionDiff = quesArr[0].questionDiff;
                        if(typeName.indexOf('单') != -1){
                            if(this.singleMultipleTable.length == 0 ){
                                this.singleMultipleTable = quesArr;
                            }else{
                                let result = false;
                                this.singleMultipleTable.forEach(item =>{
                                    if(item.questionDiff == questionDiff){
                                        result = true;
                                    }
                                })
                                if(result){
                                    this.singleMultipleTable = quesArr;
                                }else{ 
                                    quesArr.forEach(item => {
                                        this.singleMultipleTable.push(item)
                                    })
                                }
                            }
                        }else if(typeName.indexOf('多') != -1){
                            if(this.moreMultipleTable.length == 0){
                                this.moreMultipleTable = quesArr;
                            }else{
                                let result = false;
                                this.moreMultipleTable.forEach(item =>{
                                    if(item.questionDiff == questionDiff){
                                        result = true;
                                    }
                                })
                                if(result){
                                    this.moreMultipleTable = quesArr;
                                }else{ 
                                    quesArr.forEach(item => {
                                        this.moreMultipleTable.push(item)
                                    })
                                }
                            }
                        }else if(typeName.indexOf('判') != -1){
                            if(this.judgeMultipleTable.length == 0){
                                this.judgeMultipleTable = quesArr;
                            }else{
                                let result = false;
                                this.judgeMultipleTable.forEach(item =>{
                                    if(item.questionDiff == questionDiff){
                                        result = true;
                                    }
                                })
                                if(result){
                                    this.judgeMultipleTable = quesArr;
                                }else{ 
                                    quesArr.forEach(item => {
                                        this.judgeMultipleTable.push(item)
                                    })
                                }
                            }
                        }else if(typeName.indexOf('填') != -1){
                            if(this.fillMultipleTable.length == 0 ){
                                this.fillMultipleTable = quesArr;
                            }else{
                                let result = false;
                                this.fillMultipleTable.forEach(item =>{
                                    if(item.questionDiff == questionDiff){
                                        result = true;
                                    }
                                })
                                if(result){
                                    this.fillMultipleTable = quesArr;
                                }else{ 
                                    quesArr.forEach(item => {
                                        this.fillMultipleTable.push(item)
                                    })
                                }
                            }
                        }else if(typeName.indexOf('实') != -1){
                            if(this.operateMultipleTable.length == 0){
                                this.operateMultipleTable = quesArr;
                            }else{
                                let result = false;
                                this.operateMultipleTable.forEach(item =>{
                                    if(item.questionDiff == questionDiff){
                                        result = true;
                                    }
                                })
                                if(result){
                                    this.operateMultipleTable = quesArr;
                                }else{ 
                                    quesArr.forEach(item => {
                                        this.operateMultipleTable.push(item)
                                    })
                                }
                            }
                        }else if(typeName.indexOf('简') != -1){
                            if(this.writeMultipleTable.length == 0){
                                this.writeMultipleTable = quesArr;
                            }else{
                                let result = false;
                                this.writeMultipleTable.forEach(item =>{
                                    if(item.questionDiff == questionDiff){
                                        result = true;
                                    }
                                })
                                if(result){
                                    this.writeMultipleTable = quesArr;
                                }else{ 
                                    quesArr.forEach(item => {
                                        this.writeMultipleTable.push(item)
                                    })
                                }
                            }
                        }
                        this.addRandomQuestionDV = false;
                    }
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })
        },
        //删除以增加的试题
        deleteSelectedQuestion(item, i){
            //首先判断增加的试题类型
            if(item.typeName.indexOf('单') != -1){
                this.singleMultipleTable.splice(i, 1)
            }else if(item.typeName.indexOf('多') != -1){
                this.moreMultipleTable.splice(i, 1)
            }else if(item.typeName.indexOf('判') != -1){
                this.judgeMultipleTable.splice(i, 1)
            }else if(item.typeName.indexOf('填') != -1){
                this.fillMultipleTable.splice(i, 1)
            }else if(item.typeName.indexOf('简') != -1){
                this.writeMultipleTable.splice(i, 1)
            }else if(item.typeName.indexOf('实') != -1){
                this.operateMultipleTable.splice(i, 1)
            }
        },  

        //编辑试卷信息
        modifyPaperInfo(row) { 
            this.modifyFlag = true
            //查询出所有部门供选择
            //根据paperId向后台请求查询试卷信息，将信息显示于对话框中
            this.modfiyPaperForm = {
                paperId: row.paperId,
                paperName:row.paperName,
                paperScore:row.paperScore,
                paperMsg:row.paperMsg,
                passScore:row.passScore,
                state:row.state,
                examPartList:[]       
            };
            queryExamPaperById(row.paperId).then(res => {
                if(res.data.code === 200) {
                    let examPartList = res.data.data.examPartList;
                    for(let i = 0; i < examPartList.length;i++){
                        if(examPartList[i].partName.indexOf('单') != -1){
                            this.singleSelect.questionScore = examPartList[i].questionScore;
                            this.singleMultipleTable = examPartList[i].questions;
                        }else if(examPartList[i].partName.indexOf('多') != -1){
                            this.multiSelect.questionScore = examPartList[i].questionScore;
                            this.moreMultipleTable = examPartList[i].questions;
                        }else if(examPartList[i].partName.indexOf('判') != -1){
                            this.judgePart.questionScore = examPartList[i].questionScore;
                            this.judgeMultipleTable = examPartList[i].questions;
                        }else if(examPartList[i].partName.indexOf('填') != -1){
                            this.fillPart.questionScore = examPartList[i].questionScore;
                            this.fillMultipleTable = examPartList[i].questions;
                        }else if(examPartList[i].partName.indexOf('简') != -1){
                            this.writePart.questionScore = examPartList[i].questionScore;
                            this.writeMultipleTable = examPartList[i].questions;
                        }else if(examPartList[i].partName.indexOf('实') != -1){
                            this.operatePart.questionScore = examPartList[i].questionScore;
                            this.operateMultipleTable = examPartList[i].questions;
                        }
                    }
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            }) 
        },
        backToManagerPaper(){
            this.modifyFlag = false;
            this.queryExamPapers();
            this.singleMultipleTable = [];
            this.moreMultipleTable = [];
            this.fillMultipleTable = [];
            this.judgeMultipleTable = [];
            this.writeMultipleTable = [];
            this.operateMultipleTable = []
        },
        
        //删除当前试卷
        modifyState(row) { 
            const modifyStateForm = {
                paperId:row.paperId,
                paperName:row.paperName,
                paperScore:row.paperScore,
                paperMsg:row.paperMsg,
                passScore:row.passScore,
                state:'0',
                examPartList:[]
            };
            if(this.paperSwitchValue === true){
                modifyStateForm.state = '0';
            }else {
                modifyStateForm.state = '1';
            }    
            queryExamPaperById(row.paperId).then(res => {
                if(res.data.code === 200) {
                    let paper  = res.data.data.examPartList;
                    paper.forEach(item => {
                        const obj = {
                            partName: item.partName,
                            questionScore: item.questionScore,
                            questionIds:[]
                        };
                        item.questions.forEach(itemTemp =>{
                            obj.questionIds.push(itemTemp.questionId);
                        })
                        modifyStateForm.examPartList.push(obj);
                    })
                    this.modifyStateSubmit(modifyStateForm)
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });
                    return   
                }
            }) 

        },
        modifyStateSubmit(form){
            modifyPaper(form).then(res => {
            if(res.data.code === 200) {
                this.$message({
                    message: '成功禁用试卷',
                    type: 'success'
                }); 
                this.modfiyPaperForm = {
                    examPartList:[],
                };
                this.queryExamPapers();
            } else {
                this.$message({
                    message: res.data.msg,
                    type: 'error'
                });   
            }
        })
        },
        //格式化时间格式
        dateFormatter (datetime) {
            if(datetime!= '' && datetime!= null && datetime!= undefined){
                let date = new Date(datetime)
                var year = date.getFullYear()
                var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
                var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
                var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
                var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
                var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
                // 拼接 时间格式处理
                return year + '年' + month + '月' + day + '日 ' + hours + ':' + minutes + ':' + seconds
            }else {
                return ''
            }
        },
        //报送信息模板
		sendMsg(msg, type) {
			this.$message({
				message: msg,
				type: type
			});
		}
    }
};
</script>
<style lang="less" scoped>
    .fatherCard {
        width: 1672px;
        position: fixed;
        height: 90vh;
        .list_container {
            display: flex;
            flex-direction: column;
            align-items: center;
            .search_container {
                width: 100%;
                margin-bottom: 10px;
                display: flex;
                align-items: flex-end;
                justify-content: space-between;
                .el-form-item {
                    width: 300px;
                }
                .el-input {
                    width: 200px;
                }
            } 
            .el-pagination {
                margin-top: 10px;
            }
        }
    }
    
    .addQuesDialog{
        .bg{
            height: 600px;
            .search_div{
                margin-bottom: 10px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .el-input{
                    width: 200px;
                }
                .searchItem{
                    margin-right: 10px;
                }
            }
            .pagin{
                display: flex;
                justify-content: center;
                margin-top: 10px;
            }
        }
    }
    .addRandomQuesDialog{
        .bg{
            height: 250px;
            display: flex;
            align-items: center;
            flex-direction: column;
            .addParam{
                width: 300px;
                margin-bottom: 15px;
                height: 40px;
            }
            .btn {
                width: 360px;
                margin-top: 10px;
                margin-bottom: 5px;
            }
            .tip{
                font-size: 12px;
            }
        }
    }
    .switchDiv {
        display: flex;
        flex-flow: column;
        align-items: center;
    }

    


    .impoWorldInput {

        margin-right: 10px;
    }
     .createPaperContainer {
        border: 1px #E4E7ED solid;
    }
    .articleCard {
        width: 800px;
        margin-bottom: 20px;
        span {
            margin: 6px 5px 0px 5px;
        }
    }
    .clearfix {
        height:10px;
        display:flex;
        align-items: center;
        justify-content: space-between;
    }
    .selectBody {
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
    }
    .index_title{
        display: flex;
        .questionSpan {
            width: 600px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
    /* .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    .clearfix:after {
        clear: both
    } */
    .singeSelectHeader {
        /* width: 100%; */
        border: 1px #1E88E5 solid;
        padding: 5px;
        font-size: 15px;
        height: 25px;
        background-color: #1E88E5;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    
    .dialog-header {
        width: 800px;
        height: 50px;
        margin-top: -20px;
        margin-left: -20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #F8F8F8;
        
    }
    .dialog-header span {
        margin-left: 15px;
    }
    .singleArticle {
        border: 1.5px #E4E7ED solid;
        margin-bottom: 10px;
    }
    .questionsDiv {
        max-height: 100px;
        scroll-behavior: auto;
    }
    .articleName {
        height: 30px;
        font-size: 15px;
        padding-left: 10PX;
        padding-top: 10px;
        background-color: #1E88E5;
    }
    .quetionTable, .answersTable {
        border-collapse: collapse;
        border: solid 1px #eee;
    }
    .quetionTable tr {
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
    }
    .quetionTable tbody {
        color: #000;
    }
    .quetionTable th {
        font-weight: normal;
        text-align: right;
        font-size: 12px;
        border: solid 1px #eee;
        background: #f5f5f5;
        line-height: 25px;
        padding: 8px 8px !important;
    }
    .quetionTable td {
        border: solid 1px #eee;
        padding: 8px 8px !important;
        font-size: 9pt;
    }
    .createPaperTable th {
        font-weight: bold;
        text-align: right;
        font-size: 12px;
        padding: 8px 10px 5px 10px;
        color: #666;
        vertical-align: center;
    }
    .answersTable th {
        width: 50px;
        text-align: center;
        
    }
    
    .createPaperTable td {
        padding: 5px 5px;
    }
    .createPaperTable .el-select {
        width: 280px;
    }
    .createHeaderTitle {
        font-size: 14px;
        text-align: left;
        color: #666;
        font-weight: bold;
        line-height: 20px;
        padding: 10px 10px;
        background: #f5f5f5;
        margin: 0 0;
    }
    .createContainer {
        margin-left: 60px;
        margin-top: 10px;
        height: 650px;
    }
    .createPaperTable {
        border-collapse: collapse;
        border: none;
    }
    .singAnswerTip {
        margin-left: 10px;
        font-size: 12px;
        color: #909399;
    }
    /* .answerInputDiv td{
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .answerInputDiv .el-input {
        width: 620px;
        margin-left: 12px;
    } */
    .copyPaper :hover {

       cursor: pointer;
       
    }
    .copyPaper {
        height:750px;
        width: 100%;
        h1 {
            text-align: center;
            font-size: 25px;
        }
        .exam_question {
            width: 100%;
            margin-bottom: 20px;
            .partName {
                font-size: 18px;
            }
            .partBody {
                font-size: 16px;
                margin-bottom: 10px;
                .ques_div{
                    display: flex;
                    justify-content: space-between;
                }
                .left {
                    display: flex;
                }
                .jdsc {
                    margin-bottom: 100px;
                }
               
            }
        }

    }

  
</style>
